import { memo } from 'react';
import type React from 'react';

/**
 * Pretend that component from memo is normal ComponentType
 *
 * React.memo produces NamedExotic component to prevent passing stuff (I guess like displayName)
 * to the memoed component in userland:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/blob/2b52258/types/react/index.d.ts#L344
 *
 * However, that brings hell to typing, e.g. when combining memo with other HOCs, when the next HOC
 * expects ComponentType. That is the case to use this simpler type variant.
 */
export const simpleTypeMemo: <Props>(
  Component: React.ComponentType<Props>,
  propsAreEqual?: (
    prevProps: Readonly<Props>,
    nextProps: Readonly<Props>,
  ) => boolean,
) => React.ComponentType<Props> = memo;
